export default "__VITE_ASSET__DbWciSnN__"